<template>
  <div class="course-progress">
    <div class="course-progress__bar" :style="`width: ${value * 100}%`"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.course-progress {
  width: 100%;
  border-radius: 30px;
  background-color: rgba(255, 255, 255, 0.2);
  height: 5px;
  &__bar {
    height: 5px;
    border-radius: 30px;
    background-color: var(--white);
  }
}
</style>
